module.exports = __webpack_public_path__ + "img/marker_four_cyan2.528f51bb.png";